"use client";

import Image from "next/image";
import React from "react";
import { GoogleTagManagerEvents } from "../../../common";
import { BUTTON } from "../../../public/Constants/EnumConstants";
import { WhiteHamburgerMenu, WTLogoEnglishWhite } from "../../../public/Theme";
import {
    DRAWER_NAVIGATION,
    HEADER_BUTTON_ID,
    NewHeaderLinks,
    HEADER_LOGO_IMAGE_ID,
    LOGO_ALT_TEXT,
    MENU_ICON_ALT,
    slugify,
} from "./constants";
import { usePathname } from "next/navigation";
import { FRONTEND_ENDPOINTS } from "@/public/Constants/endpoints";
import dynamic from "next/dynamic";

const FlyoutLink = dynamic(() => import("../../Atoms/FlyoutLink"));
const GTMLink = dynamic(() => import("../../Atoms/GTMLink"));



const NavBarLinks = ({ drawerOpen, setDrawerOpen }) => {
    const pathname = usePathname();
    const wearthatLogoLink = pathname?.includes("shop")
        ? FRONTEND_ENDPOINTS?.SHOP
        : pathname?.includes("styling")
            ? FRONTEND_ENDPOINTS?.STYLING
            : "/";
    return (
        <div className={"flex justify-between items-center  max-w-full h-full"}>
            <button
                type={BUTTON}
                onClick={() => {
                    setDrawerOpen(!drawerOpen);
                }}
                data-drawer-target={DRAWER_NAVIGATION}
                data-drawer-show={DRAWER_NAVIGATION}
                // aria-controls={DRAWER_NAVIGATION}
                className={
                    "inline-flex items-center  text-sm  rounded-lg xl:hidden focus:outline-none focus:ring-2 "
                }
            >
                <Image
                    src={WhiteHamburgerMenu}
                    alt={MENU_ICON_ALT}
                    className={"h-full w-full"}
                    width={50}
                    height={50}
                />
            </button>
            <GTMLink
                text={"Home"}
                href={wearthatLogoLink}
                passHref
                prefetch
                replace={true}
                className={" mx-4"}
                event={GoogleTagManagerEvents.navigationInteractions}
                place="header"
                menuName={"header navigation menu"}
            >
                <Image
                    width={100}
                    height={100}
                    src={WTLogoEnglishWhite}
                    className={" h-4 sm:h-5 "}
                    alt={LOGO_ALT_TEXT}
                    id={HEADER_LOGO_IMAGE_ID}
                    data-cy={HEADER_LOGO_IMAGE_ID}
                />
            </GTMLink>
            <div
                className={
                    "hidden justify-between items-center w-full h-full xl:flex lg:w-auto mx-auto "
                }
            >
                <ul className="h-full flex flex-col mt-4 font-medium lg:flex-row  lg:mt-0 px-14 ">
                    {NewHeaderLinks?.map((item, index) => (
                        <FlyoutLink
                            key={index}
                            text={item?.title}
                            link={item?.link}
                            flyoutLinks={item?.options}
                            headerId={slugify(
                                HEADER_BUTTON_ID + `_${item?.title}`
                            )}
                        />
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default NavBarLinks;
